import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAIChatUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (chatId: string): Promise<any> => {
        return await this._aiRepository.getAIChat(chatId);
    }
}

export const GetAIChatUseCaseName = "GetAIChatUseCaseName";
